<div *ngIf="visible" [class]="getAlertClass()" role="alert">
    <div class="flex items-center">
        <!-- Icons -->
        <lucide-icon *ngIf="type === 'success'" name="check-circle" class="mr-2 h-5 w-5"></lucide-icon>
        <lucide-icon *ngIf="type === 'error'" name="x-circle" class="mr-2 h-5 w-5"></lucide-icon>
        <lucide-icon *ngIf="type === 'warning'" name="alert-triangle" class="mr-2 h-5 w-5"></lucide-icon>
        <lucide-icon *ngIf="type === 'info'" name="info" class="mr-2 h-5 w-5"></lucide-icon>

        <div class="flex-1 text-sm font-medium">
            <ng-content></ng-content>
        </div>

        <!-- Close button if dismissible -->
        <button *ngIf="dismissible" type="button"
            class="ml-auto -mx-1.5 -my-1.5 rounded-lg p-1.5 inline-flex h-8 w-8 hover:bg-black/10 transition-colors"
            (click)="close()" aria-label="Close">
            <span class="sr-only">Dismiss</span>
            <lucide-icon name="x" class="h-5 w-5"></lucide-icon>
        </button>
    </div>
</div>